import Icon from '@/components/ui/AppIcon';

interface ReviewCardProps {
  name: string;
  location: string;
  service: string;
  rating: number;
  date: string;
  review: string;
  image: string;
  alt: string;
  verified: boolean;
}

export default function ReviewCard({
  name,
  location,
  service,
  rating,
  date,
  review,
  image,
  alt,
  verified
}: ReviewCardProps) {
  return (
    <div className="bg-card rounded-lg shadow-brand p-6 transition-smooth hover:shadow-brand-lg">
      <div className="flex items-start space-x-4 mb-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-1">
            <h3 className="font-serif text-lg font-semibold text-foreground truncate">{name}</h3>
            {verified && (
              <div className="flex items-center space-x-1 text-success flex-shrink-0 ml-2">
                <Icon name="CheckBadgeIcon" size={18} variant="solid" />
                <span className="text-xs font-medium">Verified</span>
              </div>
            )}
          </div>
          <p className="text-sm text-muted-foreground">{location}</p>
          <div className="flex items-center space-x-2 mt-2">
            <div className="flex space-x-0.5">
              {[...Array(5)].map((_, index) => (
                <Icon
                  key={index}
                  name="StarIcon"
                  size={16}
                  variant={index < rating ? 'solid' : 'outline'}
                  className={index < rating ? 'text-warning' : 'text-muted-foreground'}
                />
              ))}
            </div>
            <span className="text-xs text-muted-foreground">•</span>
            <span className="text-xs text-muted-foreground">{date}</span>
          </div>
        </div>
      </div>
      <div className="mb-3">
        <span className="inline-block px-3 py-1 bg-accent text-primary text-xs font-medium rounded-full">
          {service}
        </span>
      </div>
      <p className="text-sm text-foreground leading-relaxed">{review}</p>
    </div>
  );
}